import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import editReportInstanceCommentDialog from '../../../../../../dialog.editReportInstanceCommentDialog';
import controller from './report-instance-comment.controller';
import directive from './report-instance-comment.directive';


export default angular.module('app.components.reports.myReports.reportType.reportInstanceComment', [
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  editReportInstanceCommentDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('mrReportInstanceComment', directive)
  .controller('MRReportInstanceCommentController', controller)
  .name;

console.log('app.components.reports.myReports.reportType.reportInstanceComment created');
